import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getMediaGuides from '../services/mediaguides/getMediaGuides';
import createMediaGuide from '../services/mediaguides/createMediaGuide';
import updateMediaGuide from '../services/mediaguides/updateMediaGuide';

// THUNKS
export const fetchMediaGuides = createAsyncThunk('mediaGuides/getMediaGuides', getMediaGuides.handler);
export const addMediaGuide = createAsyncThunk('mediaGuides/createMediaGuide', createMediaGuide.handler);
export const editMediaGuide = createAsyncThunk('mediaGuides/updateMediaGuide', updateMediaGuide.handler);

const initial_state = {
  lists: [],
  loading: false,
  creating: false,
  updating: false,
  initialized: false,
};

const slice = createSlice({
  name: 'mediaGuides',
  initialState: initial_state,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchMediaGuides.pending, getMediaGuides.pending)
      .addCase(fetchMediaGuides.fulfilled, getMediaGuides.fulfilled)
      .addCase(fetchMediaGuides.rejected, getMediaGuides.rejected)

      .addCase(addMediaGuide.pending, createMediaGuide.pending)
      .addCase(addMediaGuide.fulfilled, createMediaGuide.fulfilled)
      .addCase(addMediaGuide.rejected, createMediaGuide.rejected)

      .addCase(editMediaGuide.pending, updateMediaGuide.pending)
      .addCase(editMediaGuide.fulfilled, updateMediaGuide.fulfilled)
      .addCase(editMediaGuide.rejected, updateMediaGuide.rejected);
  },
});

const { reducer } = slice;
export default reducer;
